import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';

import { ClienteCarteiraPreBaixarModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        ClienteCarteiraPreBaixarModalComponent
    ],
    exports: [
        SharedModule,

        ClienteCarteiraPreBaixarModalComponent
    ],
    providers: [ ]
})
export class ClienteCarteiraPreBaixarModule { }
